import { matchPath } from 'react-router-dom';
import { route } from 'react-router-typesafe-routes';

export const WALK_IN_NAV_LINK = '/walkin';

export const WALK_IN_EHR_ROUTE = route({ path: 'walkin/ehr/:id' });

export const WALK_IN_REFERRALS_ROUTE = route({ path: 'walkin/:diagnosticType/:ehrId' });

export function isWalkInEhrRoute(pathname: string): boolean {
    return matchPath(WALK_IN_EHR_ROUTE.$path(), pathname) !== null;
}
